export default __webpack_public_path__ + "static/media/01c_fold-3.65d44e9c.mp4";